import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import { ColorModel } from '../../models/color.model';
import { ColorChangeModel } from '../../models/color-change.model';
import { FavoriteColorsService } from '../AdvancedColorPickerPopover/service/favorite-colors.service';
import { OverlayComponent } from '../../../Overlay/components/overlay.component';
import { ColorPickerCloseRequestType } from '../../enums/color-picker-close-request-types.enum';
import { Subscription } from 'rxjs';

@Component({
    selector: 'agpr-color-picker-trigger',
    templateUrl: './color-picker-trigger.component.html',
    styleUrls: ['./color-picker-trigger.component.scss'],
    standalone: false
})
export class ColorPickerTriggerComponent implements OnDestroy {

    readonly DEFAULT_COLOR_VALUE = '#000000';

    private _value: string | null = null;
    @Input() set value(v: string | null) {
        this._value = v;
        this.colorModel = ColorModel.createFromHex(v || this.DEFAULT_COLOR_VALUE);
    }
    get value(): string | null {
        return this._value;
    }

    @Input() id?: string = 'colorPickerPopover';
    @Input() showRecentColors?: { show: boolean; property?: string } | null = null;
    @Input() showFavoriteColors = true;
    @Input() brandId?: number;
    @Input() isOpen: boolean = false;
    @Input() initialFocusSelectors = ['.agpr-colorSwatchGrid-swatch--active .agpr-button', '.agpr-colorGradientPicker-foucsable'];

    @Output() isOpenChange = new EventEmitter<boolean>();

    // Emits the selected value along with the selected color type.
    @Output() valueWithTypeChange = new EventEmitter<ColorChangeModel>();
    @Output() valueChange = new EventEmitter<string>();

    @Output() favoriteColorsChange = new EventEmitter<string[]>();

    @ViewChild('overlay', { static: true })  overlay!: OverlayComponent;

    private subscriptions: Subscription[] = [];
    colorModel: ColorModel = ColorModel.createFromHex(this.DEFAULT_COLOR_VALUE);

    constructor(public favoriteColorsService: FavoriteColorsService, public cd: ChangeDetectorRef) {}

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    setValue(change: ColorChangeModel): void {
        if (change?.value) {
            this.value = change.value;
            this.valueChange.emit(change.value);
            this.valueWithTypeChange.emit(change);
        }
    }

    popupOpenChange(isOpen: boolean) {
        this.isOpen = isOpen;
        this.isOpenChange.emit(this.isOpen);
    }

    onPopoverColorSelected(change: ColorChangeModel): void {
        this.setValue(change);
    }

    onPopoverClose(closeRequestInfo: {needClose: boolean; closeRequestType: ColorPickerCloseRequestType}) {
        if (closeRequestInfo.needClose === true) {
            this.popupOpenChange(false);
        }
    }

    onfavoriteColorsChange(colors: string[]) {
        this.favoriteColorsChange.emit(colors);
        if (this.showFavoriteColors) {
            this.favoriteColorsService.saveFavoriteColors(colors);
        }
    }
}
